var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-area-page jobs" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("Navigation", {
                    attrs: {
                      page: "job-profiles",
                      only: _vm.hideNavigation ? ["logout"] : undefined,
                      "sub-link-active-key": _vm.jobProfile.id,
                      "can-add-job-profile": !_vm.isOnboarding
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _vm.loadingJobProfile && !_vm.initiallyLoaded
                    ? _c("Loading")
                    : _vm.customer
                    ? [
                        _vm.isOnboarding
                          ? _c("h1", [
                              _vm._v(
                                "Hallo " + _vm._s(_vm.customer.firstName) + "!"
                              )
                            ])
                          : _c("h1", [_vm._v("Deine Matches zum Job:")]),
                        _vm._v(" "),
                        !_vm.hasName
                          ? _c(
                              "div",
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c("b-col", { attrs: { md: "8" } }, [
                                      _c(
                                        "div",
                                        { staticClass: "title-container" },
                                        [
                                          _c("SetJobProfileName", {
                                            attrs: {
                                              "job-profile":
                                                _vm.jobProfileListItem
                                                  .jobProfile
                                            },
                                            on: { save: _vm.onSaveName }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm.isOnboarding
                          ? _c(
                              "div",
                              [
                                _c("Onboarding", {
                                  attrs: {
                                    "job-profile": _vm.jobProfileListItem,
                                    "is-initial": _vm.hasOnlyOneJobProfile
                                  },
                                  on: { close: _vm.onCloseOnboarding }
                                })
                              ],
                              1
                            )
                          : _c("div", { staticClass: "job-listing" }, [
                              _c(
                                "div",
                                {
                                  class: [
                                    "job-listing--items",
                                    {
                                      "job-listing--items-loading":
                                        _vm.loadingJobProfile
                                    }
                                  ]
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "job-listing--item" },
                                    [
                                      _c("JobProfileHead", {
                                        attrs: {
                                          "job-profile-list-item":
                                            _vm.jobProfileListItem
                                        },
                                        on: {
                                          publish: _vm.loadJobProfile,
                                          unpublish: _vm.loadJobProfile,
                                          save: _vm.loadJobProfile,
                                          closeMessages: _vm.loadJobProfile,
                                          closeAppointments: _vm.loadJobProfile,
                                          loadFavorites: function($event) {
                                            _vm.onlyFavorites = true
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("JobProfileFooter", {
                                        ref: "jobProfileFooter",
                                        attrs: {
                                          "job-profile-list-item":
                                            _vm.jobProfileListItem
                                        },
                                        on: {
                                          load:
                                            _vm.resetOnlyFavoritesAndLoadJobProfile,
                                          publish: _vm.onPublish,
                                          unpublish: _vm.onUnpublish
                                        }
                                      }),
                                      _vm._v(" "),
                                      !_vm.isPublished
                                        ? _c("JonInfo", {
                                            staticClass: "mt-3",
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "message",
                                                  fn: function() {
                                                    return [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\tDu kannst den Job nun noch bearbeiten und weitere Filter setzen.\n\t\t\t\t\t\t\t\t\t\tSobald du fertig bist, klicke\n\t\t\t\t\t\t\t\t\t\t"
                                                      ),
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: { href: "#" },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.$refs.jobProfileFooter.showPublishPopUp()
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("hier")]
                                                      ),
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\tum den Job zu veröffentlichen.\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              false,
                                              2267211228
                                            )
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (_vm.isPublished || _vm.internal) &&
                                      _vm.hasMatches
                                        ? _c("List", {
                                            ref: "list",
                                            attrs: {
                                              "job-profile-list-item":
                                                _vm.jobProfileListItem,
                                              "only-favorites":
                                                _vm.onlyFavorites
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              )
                            ])
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }